import { useState, useRef, useEffect  } from "react";
import normatecaStore from "../../stores/normatecaStore";
import { Col, Row } from "react-bootstrap";
import Ordena from "../Contenido/Ordenamiento/Ordena";
import {Accordion, AccordionBody, AccordionHeader, AccordionItem} from "react-headless-accordion";

export default function ResultadoBus(){
    // store - zuntand
    const { txtBusqueda,setFiltro,tipoFiltro,filtrar,setCambiaVigAnt,busClasif} =
    normatecaStore((state) =>( { 
        txtBusqueda: state.txtBusqueda,
        setFiltro: state.setFiltro,
        tipoFiltro:state.tipoFiltro,
        filtrar:state.filtrar,
        setCambiaVigAnt: state.setCambiaVigAnt,
        busClasif:state.busClasif,
    })); 
    const fil = useRef(null);
    const [visMenu, setVisMenu]= useState(false);
    const changeFiltro=(indiceOrd)=>{
        let vigant="";
        setVisMenu(false);
        setFiltro(indiceOrd).catch(null);
       switch(indiceOrd){
        case 0:
            vigant="vig";
            break;
        case 1:
            vigant="ant";
            break;
       }
        setCambiaVigAnt(vigant,"b").catch(null)
    }
    const visualizaMenu=()=>{
        setVisMenu(!visMenu);
    }
    useEffect(() => {
        document.addEventListener("click", clickOutsideFil, false);
        return () => {
        document.removeEventListener("click", clickOutsideFil, false);
        };
    }, []);
    const clickOutsideFil = event => {
        if (fil.current && !fil.current.contains(event.target)) {
            setVisMenu(false);
        }
    };
    
    return(
        <Row className="divBusAvaResul padBottom-1">
            <Col sm={7} className="resultBus">Resultados de búsqueda para: {txtBusqueda}</Col>
            {/* <div className="padleft-05 resultBus width-30">{txtBusqueda}</div> */}
            <Col sm={3} className="menuSupMat width-18rem" ref={fil}> 
                <Accordion className="divAcoordionFil">
                    <AccordionItem key={0}>
                        {busClasif!==""?
                            <AccordionHeader className="display-flex menuOrdenaDisabled">
                            <div className="width-95">{filtrar}</div>
                            </AccordionHeader>
                        :
                            <AccordionHeader className="menuOrdena display-flex" onClick={visualizaMenu}>
                                <div className="width-95">{filtrar}</div> 
                                <div className={visMenu? "inegi-nav-despa alignSelf-center color-blue": "inegi-nav-desp alignSelf-center color-blue"}></div>
                            </AccordionHeader>
                        }
                            
                        <AccordionBody className={visMenu? 'display-contents' : 'display-none'}>
                            <div className="accordion-body divOpcOdena" key={"div1"} >
                                <AccordionItem key={"fl"}>
                                    {tipoFiltro.map((fl,index) => {
                                        return (
                                            <div key={"fl" + index.toString()} className="accordion-body divOpcOrdenaItem"  onClick={()=>changeFiltro(index)}>
                                                {fl}
                                            </div>
                                        );
                                    })}
                                </AccordionItem>
                            </div>
                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
            </Col>
            <Col sm={3} >
                <div><Ordena opc="b"/></div>  
            </Col>
        </Row>
    )
}